/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Mixing_Program_VoInputs */

const en_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixing program and VO audio...`)
};

const fr_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mixage de l'audio du programme et de la VO...`)
};

const de_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mischprogramm und VO-Audio...`)
};

const it_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programma di mixaggio e audio VO...`)
};

const ru_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Программное микширование и озвучивание...`)
};

const es_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa de mezcla y audio VO...`)
};

const zh_cn2_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混合节目和配音音频……`)
};

const ja_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラムと VO オーディオをミキシングしています...`)
};

const hi_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिक्सिंग प्रोग्राम और वॉयस ओवर ऑडियो...`)
};

const pt_pt2_audio_description_export_status_mixing_program_vo = /** @type {(inputs: Audio_Description_Export_Status_Mixing_Program_VoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programa de mixagem e áudio de locução...`)
};

/**
* | output |
* | --- |
* | "Mixing program and VO audio..." |
*
* @param {Audio_Description_Export_Status_Mixing_Program_VoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixing_program_vo = /** @type {((inputs?: Audio_Description_Export_Status_Mixing_Program_VoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixing_Program_VoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "de") return de_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "it") return it_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "ru") return ru_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "es") return es_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "ja") return ja_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "hi") return hi_audio_description_export_status_mixing_program_vo(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_mixing_program_vo(inputs)
	return en_audio_description_export_status_mixing_program_vo(inputs)
});